import React, { Component } from 'react';

import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Badge from 'react-bootstrap/Badge';
import Popover from 'react-bootstrap/Popover';
import Modal from 'react-bootstrap/Modal';
import ReactTooltip from 'react-tooltip';
import InputGroup from 'react-bootstrap/InputGroup';
import FormControl from 'react-bootstrap/FormControl';
import Alert from 'react-bootstrap/Alert';
import Link from 'react-router-dom/Link';

// Components
import ReviewScore from './utilities/ReviewScore';
import softieImg from '../../assets/softie.PNG';

var firebase = require('firebase/app');
require('firebase/auth');
require('firebase/firestore');
require('firebase/storage');

/**
 * Handle user viewing the software page
 */
class ViewSoftwarePage extends Component {
  
  constructor(props) {
    super(props);

    this.state = {
      loaded: false, // control whether or not it has loaded in or not
      prodId: this.props.match.params.id,
      prodType: 'Software',
      prodName: '',
      prodCategory: '',
      prodPrice: 0,
      prodLink: '',
      prodDevName: '',
      prodDetails: '',
      prodSofties: '',
      prodImageURL: '',
      prodReviews: {},
      prodQAs: {},
      userLikes: {},
      userEmail: '',
      createdByDev: false,
      softies: 0,
      loggedIn: false,
      softieGiven: false,
      softieButtonDisabled: false,
      showReportModal: false,
      reportSubmitted: false,
      title: 'Reviews'
    };

    // Set up firebase parameters
    this.db = firebase.firestore();
    this.storage = firebase.storage();
    this.imgRef = this.storage.ref('product_images');

    this.handleSoftieClick = this.handleSoftieClick.bind(this);
    this.getTitle = this.getTitle.bind(this);
    this.getSoftieButton = this.getSoftieButton.bind(this);
    this.handleReportPage = this.handleReportPage.bind(this);
    this.submitReport = this.submitReport.bind(this);
    this.reportSubmittedAlert = this.reportSubmittedAlert.bind(this);
  }

  /**
   * Load and set the data
   */
  async componentDidMount() {
    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ userEmail: user.email, loggedIn: true });
      } else {
        this.setState({ loggedIn: false });
      }
      this.db
        .collection('software_pages')
        .doc(this.state.prodId)
        .get()
        .then(async doc => {
          if (doc.exists) {
            // Add doc data
            let docData = doc.data();
            await this.setState({
              prodType: docData.prodType,
              prodName: docData.prodName,
              prodCategory: docData.prodCategory,
              prodPrice: docData.prodPrice,
              prodDetails: docData.prodDetails,
              prodDevName: docData.prodDevName,
              prodLink: docData.prodLink,
              prodSofties: docData.softies,
              prodReviews: docData.prodReviews,
              prodQAs: docData.prodQAs,
              userLikes: docData.userLikes,
              softies: docData.softies,
              createdByDev: docData.createdByDev,
              softieGiven: docData.userLikes.includes(this.state.userEmail)
                ? true
                : false,
              prodRating: (docData.reviewTotal / docData.reviewCount).toFixed(
                2
              ),
            });
            this.imgRef.child(this.props.match.params.id).getDownloadURL().then(url => {
              this.setState({
                prodImageURL: url,
                loaded: true
              })
            });
          }
        })
        .catch(err => {
          console.log('Error getting document', err);
        });

      let _this = this;

      var imagePathRefernece = this.storage.ref(
        'product_images/' + this.props.match.params.id
      );
      imagePathRefernece
        .getDownloadURL()
        .then(url => {
          // `url` is the download URL for 'images/stars.jpg'
          // Or inserted into an <img> element:
          _this.setState({ prodImageURL: url });
        })
        .catch(error => {
          // Handle any errors
          console.log('Error loading file', error);
        });
    });
  }

  handleSoftieClick() {
    if (!this.state.loggedIn) {
      console.log('Called!');
      return (
        <Popover id="popover-basic">
          <Popover.Title as="h3">Popover right</Popover.Title>
          <Popover.Content>
            And here's some <strong>amazing</strong> content. It's very
            engaging. right?
          </Popover.Content>
        </Popover>
      );
    }
    let ref = this.db.collection('software_pages').doc(this.state.prodId);
    this.setState({
      softieGiven: !this.state.softieGiven,
      softieButtonDisabled: true,
    });

    return this.db
      .runTransaction(transaction => {
        // This code may get re-run multiple times if there are conflicts.
        return transaction.get(ref).then(doc => {
          if (!doc.exists) {
            console.log('Document does not exist!');
          } else {
            var newSofties = this.state.softieGiven
              ? doc.data().softies + 1
              : doc.data().softies - 1;
            var newUserLikes = this.state.softieGiven
              ? doc.data().userLikes.concat(this.state.userEmail)
              : doc
                  .data()
                  .userLikes.filter(uId => uId !== this.state.userEmail);
            this.setState({ softies: newSofties, softieButtonDisabled: false }); // Update the state as well
            transaction.update(ref, {
              softies: newSofties,
              userLikes: newUserLikes,
            });
          }
        });
      })
      .then(() => {
        console.log('Transaction successfully committed!');
      })
      .catch(error => {
        console.log('Transaction failed: ', error);
      });
  }

  handleReportPage() {
    this.setState({ showReportModal: true });
  }

  submitReport() {
    /*
     * TODO: Create this
     */
    this.db
      .collection('page_reports')
      .doc()
      .set({ id: this.props.match.params })
      .then(result => {
        this.setState({ reportSubmitted: true, showReportModal: false });
      });
  }

  getTitle() {
    return this.state.createdByDev ? (
      <h4>
        {this.state.prodName}{' '}
        <Badge pill variant="primary">
          {' '}
          Dev Page{' '}
        </Badge>
        <Badge>
          <i
            className="fas fa-flag icon-large"
            onClick={this.handleReportPage}
          ></i>
        </Badge>
      </h4>
    ) : (
      <h4>
        {this.state.prodName}{' '}
        <Badge pill variant="primary">
          {' '}
          User Made{' '}
        </Badge>
        <Badge>
          <i
            className="fas fa-flag icon-large"
            onClick={this.handleReportPage}
          ></i>
        </Badge>
      </h4>
    );
  }

  getSoftieButton() {
    let softieClass = this.state.softieGiven ? 'softieGiven' : 'softieNotGiven';
    const softieStyle = {
      verticalAlign: 'middle',
    };
    return this.state.loggedIn ? (
      <div>
        <b style={{ fontSize: '1.9em' }}>
          {' '}
          {this.state.softies}
          <input
            type="image"
            id="image"
            alt="Give Softie"
            width="35px"
            height="60px"
            disabled={this.state.softieButtonDisabled}
            style={softieStyle}
            className={softieClass}
            src={softieImg}
            onClick={this.handleSoftieClick}
          />
        </b>
      </div>
    ) : (
      <div>
        <b style={{ fontSize: '1.9em' }}>
          {' '}
          {this.state.softies}
          <input
            type="image"
            id="image"
            alt="Give Softie"
            width="35px"
            height="60px"
            disabled={false}
            style={softieStyle}
            className={softieClass}
            src={softieImg}
            data-tip
            data-for="showSoftie"
          />
          <ReactTooltip id="showSoftie" place="left" type="dark" effect="float">
            <span>You need to be logged in to do that!</span>
          </ReactTooltip>
        </b>
      </div>
    );
  }

  reportSubmittedAlert() {
    return this.state.reportSubmitted ? (
      <Alert variant="info">
        {' '}
        You're report has been submitted. Thank you for flagging!{' '}
      </Alert>
    ) : (
      <div></div>
    );
  }

  render() {
    // Determine the class the button should be
    return (
      <div className="container">
        <this.reportSubmittedAlert />
        <div style={headerMain}>
          <table style={tableStyle}>
            <tbody>
              <tr>
                <th style={colStyle1}>
                  {
                    this.state.loaded ?
                      <Image src={this.state.prodImageURL} style={imageStyle} />
                    :
                      <div></div>
                  }
                </th>
                <th style={colStyle2}>
                  <this.getTitle />
                  <h6 style={{ padding: '0px 30px 0px 0px' }}>
                    {' '}
                    <b>Type</b>: {this.state.prodType}{' '}
                  </h6>
                  <h6>
                    <b>Category</b>: {this.state.prodCategory}{' '}
                  </h6>
                  <h6>
                    {' '}
                    <b>Developer name:</b> {this.state.prodDevName}{' '}
                  </h6>
                  <Button variant="outline-primary" href={this.state.prodLink}>
                    View Product
                  </Button>
                </th>
              </tr>
            </tbody>
          </table>

          {/* Give softie button */}
          <div style={softieTopRightStyle}>
            <this.getSoftieButton />
          </div>
        </div>
        <br />
        <Card>
          <Card.Header> Description </Card.Header>
          <Card.Body> {this.state.prodDetails} </Card.Body>
        </Card>
        <br />
        {/* Reviews Card */}
        <Card>
          <Card.Header>Reviews</Card.Header>
          <Card.Body>
            <ReviewScore rating={this.state.prodRating} />
            <br />
            <Link to={'/product_reviews/' + this.props.match.params.id}>
              <Button variant="outline-primary"> Go to reviews page</Button>
            </Link>
          </Card.Body>
        </Card>
        <br />
        {/* QA Card */}
        <Card>
          <Card.Header>QA</Card.Header>
          <Card.Body>
            <Link to={'/product_qa/' + this.props.match.params.id}>
              <Button variant="outline-primary">Go to QA page</Button>
            </Link>
          </Card.Body>
        </Card>
        <Modal
          show={this.state.showReportModal}
          onHide={() => this.setState({ showReportModal: false })}
          animation={false}
        >
          <Modal.Header closeButton>
            <Modal.Title>Report software page</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            Feel something is wrong with this page? Some mischievous user at
            work here? Let us know and we'll take a look at it.
            <hr />
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Checkbox aria-label="Checkbox for following text input" />
              </InputGroup.Prepend>
              <FormControl
                aria-label="Text input with checkbox"
                placeholder={'The page contains inappropriate content'}
                disabled
              />
            </InputGroup>
            <InputGroup className="mb-3">
              <InputGroup.Prepend>
                <InputGroup.Checkbox aria-label="Checkbox for following text input" />
              </InputGroup.Prepend>
              <FormControl
                aria-label="Text input with checkbox"
                placeholder={
                  'The page contains links to irrelevant or inappropriate content'
                }
                disabled
              />
            </InputGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => this.setState({ showReportModal: false })}
            >
              Close
            </Button>
            <Button variant="primary" onClick={this.submitReport}>
              Submit Report
            </Button>
          </Modal.Footer>
        </Modal>
        <br /> <br /> <br /> <br />
      </div>
    );
  }
}

const headerMain = {
  position: 'relative',
};

const softieTopRightStyle = {
  position: 'absolute',
  top: '50%',
  right: '0%',
  msTransform: 'translate(-0.5%, -50%)',
  transform: 'translate(-0.5%, -50%)',
  padding: '6px',
  margin: '8px 0px',
  outline: 'none',
};

const softieStyle = {
  verticalAlign: 'middle',
};

const imageStyle = {
  width: '150px',
  height: '150px',
};

const tableStyle = {
  tableLayout: 'auto',
  width: '100%',
  align: 'center',
  float: 'center',
};

const colStyle1 = {
  width: '160px',
  height: '160px',
  margin: '0px 40px 0px 0px',
};

const colStyle2 = {
  padding: '5px',
  margin: '0px 40px 0px 0px',
};

export default ViewSoftwarePage;
